import { NavLink } from "react-router-dom";
import { publicUrlFor } from "../../../../globals/constants";
import { caseStudies } from "../../../../globals/neuron-content";

function SectionCaseStudy2() {
  return (
    <div className="section-full p-t110 p-b80 sx-bg-white sx-case-study2-outer">
      <div className="container">
        <div className="large-title-block">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="section-head left">
                <div className="sx-head-s-title">Field Operations</div>
                <div className="sx-head-l-title"><h2 className="sx-title">Project Security Across the Region</h2></div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="large-title-info">
                <p>Each deployment combines risk analysis, real-time coordination and local stakeholder alignment for safer project delivery.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-content">
        <div className="sx-case-study-bx2-wrap">
          <div className="row m-b30">
            {caseStudies.map((item, i) => (
              <div key={item.title} className={i % 3 === 1 ? "col-xl-6 col-lg-4 col-md-6 col-sm-6" : "col-xl-3 col-lg-4 col-md-6 col-sm-6"}>
                <div className="sx-case-study-bx2 sx-overlay-effect" style={{ backgroundImage: `url(${publicUrlFor(item.image)})` }}>
                  <div className="sx-case-media sx-img-overlay"><NavLink to={`/operations/${item.slug}`} className="sx-case-link"><i className="flaticon-up-right-arrow" /></NavLink></div>
                  <div className="sx-case-info">
                    <div className="sx-s-title">{item.category}</div>
                    <NavLink className="sx-l-title" to={`/operations/${item.slug}`}><h2 className="sx-title">{item.title}</h2></NavLink>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="sx-bnr-readmore text-center"><NavLink to="/operations" className="site-button sx-btn-primary icon sx-btn-lg"><i className="fa fa-long-arrow-right" />View Operations</NavLink></div>
        </div>
      </div>
    </div>
  );
}

export default SectionCaseStudy2;
